import React, { useContext, useEffect, useCallback, useRef } from 'react'
import styles from './styles.module.css'
import { Checkbox, Input } from '../../../components/ModalInputs'
import EditableSelect from '../../../components/EditableSelect'
import { StaffRosterContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { getSuggestions } from '../../../actions/personnel/personnel'

const edZvan = [
  { name: 'Доцент' },
  { name: 'Профессор' }]


const katos = [
  'без категории',
  'высшая категория',
  'первая категория']
const katsov = [
  'без категории',
  'высшая категория',
  'первая категория']
const pochet = []


export default function Additional() {

  const dispatch = useDispatch()

  const { allForms, addMode, personTabData, updateInitialValues } = useContext(StaffRosterContext)

  const { personDropdawn } = useSelector(state => state.personnel)
  const { additional } = personTabData || {}
  const { education, vuz, specialisation, scn_degree, razryad } = personDropdawn || {}

  const { values, setFieldValue, setValues } = allForms

  // Получаем значения вкладки additional
  const additionalValues = values.additional || {}

  // Ref для отслеживания последних загруженных данных
  const lastSyncedAdditionalRef = useRef(null)

  // Кастомный handleChange для вложенных полей
  const handleAdditionalChange = (e) => {
    const { name, value, type, checked } = e.target
    setFieldValue(`additional.${name}`, type === 'checkbox' ? checked : value)
  }

  // Кастомный setFieldValue для вложенных полей
  const setAdditionalFieldValue = useCallback((name, value) => {
    setFieldValue(`additional.${name}`, value)
  }, [setFieldValue])

  const formatOptions = (arr) => {
    if (!arr) return []
    return arr.map(item => ({
      name: item.name || item,
      value: item.name || item
    }))
  }

  // Загрузка справочников (один раз)
  useEffect(() => {
    dispatch(getSuggestions('education'))
    dispatch(getSuggestions('vuz'))
    dispatch(getSuggestions('specialisation'))
    dispatch(getSuggestions('scn_degree'))
    dispatch(getSuggestions('razryad'))
  }, [dispatch])

  // Синхронизация формы с данными из API
  useEffect(() => {
    // Проверяем что данные изменились (сравниваем с последними синхронизированными)
    const additionalJson = JSON.stringify(additional)
    if (!addMode && additional && lastSyncedAdditionalRef.current !== additionalJson) {
      lastSyncedAdditionalRef.current = additionalJson
      setValues(prev => ({
        ...prev,
        additional: { ...additional }
      }))
      // Сохраняем начальные значения для отслеживания изменений
      if (updateInitialValues) {
        updateInitialValues('additional', additional)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additional, addMode])

  return (
    <div className={styles.tabWrapper}>
      {/* Контактная информация */}
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <Input label='Телефон мобильный' highlight name='mobile_phone' value={additionalValues.mobile_phone || ''} onChange={handleAdditionalChange} />
          <Input label='Skype' name='skype' value={additionalValues.skype || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Телефон рабочий' name='phone_work' value={additionalValues.phone_work || ''} onChange={handleAdditionalChange} />
          <Input label='Телефон домашний' name='phone_home' value={additionalValues.phone_home || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='E-mail' highlight name='email' value={additionalValues.email || ''} onChange={handleAdditionalChange} />
        </div>
      </div>

      {/* Образование */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Образование</h3>
        <div className={styles.inputsRow}>
          <EditableSelect title='Образование' highlight valuesName='education' value={additionalValues.education || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(education)} />
          <EditableSelect title='ВУЗ' highlight valuesName='vuz' value={additionalValues.vuz || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(vuz)} />
        </div>
        <div className={styles.inputsRow}>
          <EditableSelect title='Специальность' highlight valuesName='specialisation' value={additionalValues.specialisation || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(specialisation)} />
        </div>
        <div className={styles.inputsRow}>
          <EditableSelect title='Ученая степень' valuesName='scn_degree' value={additionalValues.scn_degree || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(scn_degree)} />
          <EditableSelect title='Ученое звание' valuesName='scnrank' value={additionalValues.scnrank || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(edZvan)} />
        </div>
      </div>

      {/* Профессия */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Профессия</h3>
        <div className={styles.inputsRow}>
          <Input label='Основная' name='mainprofession' value={additionalValues.mainprofession || ''} onChange={handleAdditionalChange} />
          <Input label='Код по ОКПДТР' name='mainprofcode' value={additionalValues.mainprofcode || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Другая' name='otherprofession' value={additionalValues.otherprofession || ''} onChange={handleAdditionalChange} />
          <Input label='Код по ОКПДТР' name='otherprofcode' value={additionalValues.otherprofcode || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Общий стаж на момент поступления' highlight name='all_exp' value={additionalValues.all_exp || ''} onChange={handleAdditionalChange} />
          <Input label='Педагогический стаж на момент поступления' highlight name='ped_exp' value={additionalValues.ped_exp || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <EditableSelect title='Разряд' valuesName='razryad' value={additionalValues.razryad || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(razryad)} />
          <Input label='Нагрузка' name='nagruzka' value={additionalValues.nagruzka || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <EditableSelect title='Категория (осн)' highlight valuesName='category_main' value={additionalValues.category_main || 'без категории'} setFieldValue={setAdditionalFieldValue} options={formatOptions(katos)} />
          <EditableSelect title='Почетное звание' valuesName='honorary_title' value={additionalValues.honorary_title || ''} setFieldValue={setAdditionalFieldValue} options={formatOptions(pochet)} />
        </div>
        <div className={styles.inputsRow}>
          <EditableSelect title='Категория (сов)' valuesName='category_sov' value={additionalValues.category_sov || 'без категории'} setFieldValue={setAdditionalFieldValue} options={formatOptions(katsov)} />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Дата решения аттестационной комиссии (осн)'
            name='attestation_date_main'
            value={additionalValues.attestation_date_main || ''}
            onChange={handleAdditionalChange}
            type='date'
          />
        </div>
        <div className={styles.inputsRow}>
          <Checkbox label='Соответствие занимаемой должности' name='position_compliance_main' checked={additionalValues.position_compliance_main || false} onChange={handleAdditionalChange} />
          <Checkbox label='Не аттестовывается' name='no_attestation_main' checked={additionalValues.no_attestation_main || false} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Дата решения аттестационной комиссии (совм)'
            name='attestation_date_sov'
            value={additionalValues.attestation_date_sov || ''}
            onChange={handleAdditionalChange}
            type='date'
          />
        </div>
        <div className={styles.inputsRow}>
          <Checkbox label='Соответствие занимаемой должности' name='position_compliance_sov' checked={additionalValues.position_compliance_sov || false} onChange={handleAdditionalChange} />
          <Checkbox label='Не аттестовывается' name='no_attestation_sov' checked={additionalValues.no_attestation_sov || false} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Надбавки' name='allowances' value={additionalValues.allowances || ''} onChange={handleAdditionalChange} />
        </div>
      </div>

      {/* Прочее */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Прочее</h3>
        <div className={styles.inputsRow}>
          <Input label='Надбавки' name='other_allowances' value={additionalValues.other_allowances || ''} onChange={handleAdditionalChange} />
          <Input label='S/N ноутбука' name='laptop_sn' value={additionalValues.laptop_sn || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Сведения о научно-методич. деятельности' name='scientific_activity' value={additionalValues.scientific_activity || ''} onChange={handleAdditionalChange} />
        </div>
        <div className={styles.inputsRow}>
          <Input label='Сведения о внеурочной деятельности' name='extracurricular_activity' value={additionalValues.extracurricular_activity || ''} onChange={handleAdditionalChange} />
        </div>
      </div>
    </div>
  )
}
